export default __webpack_public_path__ + "static/media/FinanceImg.938cb245.svg";